import { render, staticRenderFns } from "./addFileWhiteDialog.vue?vue&type=template&id=673b45e7&scoped=true"
import script from "./addFileWhiteDialog.vue?vue&type=script&lang=js"
export * from "./addFileWhiteDialog.vue?vue&type=script&lang=js"
import style0 from "./addFileWhiteDialog.vue?vue&type=style&index=0&id=673b45e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b45e7",
  null
  
)

export default component.exports